import { useLayoutEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SERVER_URL } from "../../util/url";

function ModifiedRecipe() {
    const location = useLocation();
    const navigate = useNavigate();
    const recipeName = location.pathname.substring(31);
    const [modifiedData, setModifiedDate] = useState("");
    const [recipe, setRecipe] = useState({});
    const [setPoint, setSetPoint] = useState([]);
    const [dataIsLoaded, setDataIsLoaded] = useState(false);
    const [onlyModifiedParameters, setOnlyModifiedParameters] = useState(true);
    const causalChange = useRef();
    const special = useRef();
    const descriptionChange = useRef();

    const fetchRecipe = async (signal) => {
        await fetch(SERVER_URL + "/recipes?recipe_name=" + location.pathname.substring(31), {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== null) {
                    recipe.id = data.data[0].id;
                    recipe.name = data.data[0].recipe_name;
                    recipe.op_id = data.data[0].op_id;
                    setRecipe(data.data[0]);
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    const fetchSetpoint = async (signal) => {
        setPoint.length = 0;
        await fetch(SERVER_URL + "/nominalsp?recipe_name=" + recipeName, {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== null) {
                    data.data.forEach((item) => {
                        const param = item["parameter"].split(" impostato");
                        setPoint.push({
                            id: item["id"],
                            parameter: param[0],
                            tolerance: item["tolerance"],
                            value: item["value"],
                            new_value: null,
                            unit: item["unit"],
                        });
                    });
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
        setSetPoint([...setPoint]);
    };

    const fetchChangedSetPoint = async (signal) => {
        await fetch(SERVER_URL + "/changesp?recipe_id=" + recipe.id, {
            method: "GET",
            signal: signal,
        })
            .then((response) => response.json())
            .then((data) => {
                if (data !== null) {
                    data.data.forEach((sp) => {
                        if(modifiedData === "") setModifiedDate(sp["start"]);
                        setPoint.forEach((osp, index) => {
                            if (sp.setpoint_id === osp.id) {
                                setPoint[index].new_value = sp.new_value;
                            }
                        });
                    });
                    setSetPoint([...setPoint]);
                }
            })
            .catch((err) => {
                if (err.name === "AbortError") {
                    console.log("request aborted");
                } else {
                    console.log(err);
                }
            });
    };

    const handleModifiedRecipe = async (status) => {
        var b;
        if (status === true) {
            b = {
                info: "confirm",
                confirm: status,
                name: recipeName,
                mod_reason: causalChange.current.value,
                special: special.current.checked,
                description: descriptionChange.current.value,
                version: recipe["version"],
                compound: recipe["compound"],
                machine_id: recipe["machine_id"],
                mould_id: recipe["mould_id"]
            };
        } else {
            b = {
                info: "confirm",
                name: recipeName,
                confirm: false
            };
        }
        
        await fetch(SERVER_URL + "/updaterecipeinfo", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(b),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.data && data.data === "done") {
                    navigate("/homepage/recipeslist");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const loadData = async (signal) => {
        await fetchRecipe(signal);
        await fetchSetpoint(signal);
        await fetchChangedSetPoint(signal);
        setDataIsLoaded(true);
    };

    function formatDate(date) {

        const d = new Date(date);
        const day = d.getDate()>=10 ? d.getDate() : "0"+d.getDate();
        const month = (d.getMonth()+1 >= 10) ? d.getMonth()+1 : "0" + (d.getMonth()+1);
        const year = d.getFullYear();
        const hour = d.getHours()>=10 ? d.getHours() : "0" + d.getHours();
        const minutes = d.getMinutes()>=10 ? d.getMinutes() : "0" + d.getMinutes();
        const seconds = d.getSeconds()>=10 ? d.getSeconds() : "0" + d.getSeconds();

        return day + "/" + month + "/" + year + " alle " + hour + ":" + minutes + ":" + seconds;

    };

    useLayoutEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        loadData(signal);

        return () => {
            controller.abort();
        };
    }, []);

    return (
        <div className={"recipe p-5 bg-light " + (dataIsLoaded ? null : "d-flex align-items-center")}>
            {dataIsLoaded ? (
                <div>
                    <div className="d-flex">
                        <p className="fw-bold fs-4 text-secondary me-2"> Setpoint List - Ricette </p>
                        <p className="fw-bold fs-4 text-secondary text-decoration-underline"> {recipe.machine_name} </p>
                    </div>
                    <p> Ricetta modificata {formatDate(modifiedData)}</p>
                    <div className="d-flex my-3">
                        <p className={"m-0 me-4 my-auto " + (onlyModifiedParameters ? "text-secondary" : "fw-bold text-primary")}> Tutti i parametri </p>
                        <div className="form-check form-switch">
                            <input
                                className="form-check-input"
                                style={{ width: "3.4em", height: "1.7em" }}
                                type="checkbox"
                                role="switch"
                                id="flexSwitchCheckChecked"
                                onChange={() => setOnlyModifiedParameters(!onlyModifiedParameters)}
                                checked={onlyModifiedParameters}
                            />
                        </div>
                        <p className={"m-0 ms-4 my-auto " + (!onlyModifiedParameters ? "text-secondary" : " fw-bold text-primary")}> Solo parametri modificati </p>
                    </div>
                    <div>
                        <div className="row">
                            <div className="col-8">
                                <div className="card">
                                    <table className="table">
                                        <thead>
                                            <tr>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">PARAMETRI</p>
                                                </th>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">VALORE</p>
                                                </th>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-danger">NUOVO VALORE</p>
                                                </th>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">TOLLERANZA</p>
                                                </th>
                                                <th scope="col">
                                                    <p className="m-0 fs-6 text-secondary">UNITÀ</p>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {setPoint.map((item, index) => {
                                                if (onlyModifiedParameters && item["new_value"] === null) return null;
                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <p className="m-0 mt-1"> {item["parameter"]} </p>
                                                        </td>
                                                        <td>
                                                            {" "}
                                                            <p className="m-0 mt-1"> {item["value"]} </p>
                                                        </td>
                                                        <td>
                                                            <p className="m-0 mt-1 text-danger"> {item["new_value"]} </p>
                                                        </td>
                                                        <td>
                                                            <p className="m-0 mt-1"> {item["tolerance"]} % </p>
                                                        </td>
                                                        <td>
                                                            {" "}
                                                            <p className="m-0 mt-1"> {item["unit"]} </p>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="col">
                                <div className="card p-5">
                                    <p className="fw-bold">Causale modifica</p>
                                    <input ref={causalChange} />
                                    <div className="d-flex mt-3">
                                        <input className="form-check-input me-3" type="checkbox" value="" id="flexCheckDefault" ref={special} />
                                        <p> Ricetta temporanea (special)</p>
                                    </div>
                                    <p> Descrizione </p>
                                    <textarea placeholder="Scrivi una breve descrizione della modifica" ref={descriptionChange} />
                                    <button type="button" className="btn btn-success mt-4 mb-2" style={{ backgroundColor: "#298683" }} onClick={() => handleModifiedRecipe(true)}>
                                        <p className="m-0 fs-6"> CONFERMA MODIFICHE </p>
                                    </button>
                                    <button type="button" className="btn btn-light my-2" onClick={() => handleModifiedRecipe(false)}>
                                        <p className="m-0 fs-6"> NON SALVARE MODIFICHE </p>
                                    </button>
                                </div>
                                <div>
                                    <p className="my-3 fw-bold fs-4">Codici aggiuntivi</p>
                                    <div className="card p-3">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        <p className="m-0 fs-6 text-secondary">PARAMETRI</p>
                                                    </th>
                                                    <th scope="col">
                                                        <p className="m-0 fs-6 text-secondary">VALORI</p>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <th>
                                                        <p className="m-0 fs-6">Stampo</p>
                                                    </th>
                                                    <td>
                                                        <p className="m-0 fs-6"> {recipe["mould_id"]} </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <p className="m-0 fs-6">Prodotto/Articolo</p>
                                                    </th>
                                                    <td>
                                                        <p className="m-0 fs-6"> {recipe["product_id"]} </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <p className="m-0 fs-6">Mescola</p>
                                                    </th>
                                                    <td>
                                                        <p className="m-0 fs-6"> {recipe["compound"]} </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <p className="m-0 fs-6">Pressa</p>
                                                    </th>
                                                    <td>
                                                        <p className="m-0 fs-6"> {recipe["op_id"]} </p>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>
                                                        <p className="m-0 fs-6">Numero cavità</p>
                                                    </th>
                                                    <td>
                                                        <p className="m-0 fs-6"> {recipe["number_cavities"]} </p>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="box mx-auto">
                    <div className="text-center">
                        <div className="spinner-border text-primary my-2" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                        <p>Caricamento dei dati ...</p>
                    </div>
                </div>
            )}
        </div>
    );
}

export default ModifiedRecipe;
